export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-20-8671c64c3632bba798d8ced3de935398.jpg";